import { useMemo } from 'react';

export interface ChatMsgLike {
  id: string;
  role: 'user' | 'assistant';
}

export function useLatestLumiAvatar(messages: ChatMsgLike[]) {
  const latestAssistantId = useMemo(() => {
    const assistants = messages?.filter(m => m.role === 'assistant') || [];
    return assistants.length > 0 ? assistants[assistants.length - 1].id : undefined;
  }, [messages]);

  const avatarSize = useMemo(() => {
    try {
      const raw = getComputedStyle(document.documentElement).getPropertyValue('--lumi-avatar-size').trim();
      if (!raw) return 28; // default ~10% reduction from 32
      const match = raw.match(/(\d+(?:\.\d+)?)/);
      const n = match ? parseFloat(match[1]) : 28;
      return Math.max(16, Math.min(96, Math.round(n)));
    } catch {
      return 28;
    }
  }, []);

  return { latestAssistantId, avatarSize };
}


